<template lang="html">
  <div class="tg-banner overflow-hidden border-t border-b border-default bg-sky-100 py-2 whitespace-nowrap">
    <div class="tg-banner__body sm-max:-translate-x-24 flex gap-8 text-sm">
      <span v-for="index in 10" :key="index">
        Эксклюзив — только в Telegram: @{{ brandInfo.tgName }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { brandInfo } from '#Brand/info'
</script>
